import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as FarmCadastralSheetActions from '../_actions/farmCadastralSheet';
import { FarmCadastralSheet } from '../_models';

export interface FarmCadastralSheetState extends EntityState<FarmCadastralSheet> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<FarmCadastralSheet> = createEntityAdapter<FarmCadastralSheet>();

const initialState: FarmCadastralSheetState = adapter.getInitialState({
  loading: false,
  error: null,
});

const farmCadastralSheetReducer = createReducer(
  initialState,

  on(FarmCadastralSheetActions.loadFarmCadastralSheets, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(FarmCadastralSheetActions.loadFarmCadastralSheetsSuccess, (state, { farmCadastralSheets }) =>
    adapter.setAll(farmCadastralSheets, { ...state, loading: false })
  ),

  on(FarmCadastralSheetActions.loadFarmCadastralSheetsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(FarmCadastralSheetActions.addFarmCadastralSheetSuccess, (state, { farmCadastralSheet }) =>
    adapter.addOne(farmCadastralSheet, state)
  ),

  on(FarmCadastralSheetActions.updateFarmCadastralSheetSuccess, (state, { farmCadastralSheet }) =>
    adapter.upsertOne(farmCadastralSheet, state)
  ),

  on(FarmCadastralSheetActions.deleteFarmCadastralSheetSuccess, (state, { id }) =>
    adapter.removeOne(id, state)
  ),

  on(
    FarmCadastralSheetActions.addFarmCadastralSheetFailure,
    FarmCadastralSheetActions.updateFarmCadastralSheetFailure,
    FarmCadastralSheetActions.deleteFarmCadastralSheetFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: FarmCadastralSheetState | undefined, action: Action) {
  return farmCadastralSheetReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
